module.exports = __webpack_public_path__ + "static/media/background-colored.978308c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueDigital/background-colored.jpg
// module id = 3582
// module chunks = 0